<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import shasenKubunApi from 'src/apis/masters/shasen_kubun'

const api = shasenKubunApi
const displayPageName = '車線区分'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      list: [],
      saveCandidate: {},
      showSaveModal: false,
      showPasswordModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await api.index()
        this.list = data
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.saveCandidate,
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
